import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot} from "@angular/router";
import {AuthService} from "../services/auth.service";


@Injectable()
export class AuthGuard
  implements CanActivate, CanActivateChild {
  constructor(
    protected router: Router,
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {

    const cannot = !!localStorage.getItem('jwtToken');

    if (!cannot) {
      this.router.navigate(['auth/login']).catch(console.error);
    }

    return cannot;
  }

  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    return this.canActivate(next, state);
  }
}
